module.exports = __webpack_public_path__ + "static/media/targeting_mobile.53f1a5cc.png";